/* V162.1 — Early-bird scarcity counter.
   Shows: "Zostáva X miest pre lifetime 50% OFF · Y už zahlasovaných"

   Polls /api/agent-referrals/early-bird every 15s for live updates.
   Compact + full layouts via `compact` prop.
*/
import { useEffect, useState } from "react";
import axios from "axios";
import { Flame } from "lucide-react";
import { API } from "../../config";

export default function EarlyBirdCounter({ compact = false, accent = "#F59E0B" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () =>
      axios
        .get(`${API}/agent-referrals/early-bird`)
        .then((r) => { if (!cancelled) setData(r.data); })
        .catch(() => {});
    load();
    const id = setInterval(load, 15_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!data) return null;

  if (data.sold_out) {
    return (
      <div
        className="text-[10px] uppercase tracking-widest font-black flex items-center gap-1"
        style={{ color: "#71717a" }}
        data-testid="early-bird-soldout"
      >
        <Flame className="w-3 h-3" />
        Lifetime 50% OFF — vypredané ({data.total}/{data.total})
      </div>
    );
  }

  if (compact) {
    return (
      <div
        className="text-[10px] uppercase tracking-widest font-black flex items-center gap-1"
        style={{ color: accent }}
        data-testid="early-bird-counter"
      >
        <Flame className="w-3 h-3" />
        Zostáva {data.remaining}/{data.total} miest · {data.claimed} už zahlasovaných
      </div>
    );
  }

  return (
    <div
      className="bg-zinc-900 border p-3"
      style={{ borderColor: accent }}
      data-testid="early-bird-counter-full"
    >
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] uppercase tracking-widest font-black" style={{ color: accent }}>
          🔥 Lifetime 50% OFF · obmedzené miesta
        </span>
        <span className="text-xs font-black text-white">
          {data.remaining} / {data.total}
        </span>
      </div>
      <div className="h-1.5 bg-zinc-800 overflow-hidden">
        <div
          className="h-full transition-all duration-700"
          style={{ width: `${data.fraction_pct}%`, background: accent }}
        />
      </div>
      <p className="text-[10px] text-zinc-500 mt-1.5 leading-snug">
        Prvých {data.total} ľudí ktorí splnia 3-friend referral získa lifetime €44.50/mo. Po vyčerpaní cena ide na default €66.75/mo.
      </p>
    </div>
  );
}
